export default __webpack_public_path__ + "static/media/darius_x_wayne_snow.3c715ae1.png";